import { Routes } from '@angular/router';
import { GenerationHabilitationsComponent } from './generation-csv/generation-csv.component';
import { SuiviParcellairesViticolesComponent } from '../suivi-parcellaires-viticoles/suivi-parcellaires-viticoles.component';
import { GenerationDeclarationsComponent } from './generation-declarations/generation-declarations.component';
import { GenerationJuresComponent } from './generation-jures/generation-jures.component';
import { GenerationEchantillonsComponent } from './generation-echantillons/generation-echantillons.component';
import { GenerationOperateursComponent } from './generation-operateurs/generation-operateurs.component';

export const EXPORT_ROUTES: Routes = [
    {
        path: '',
        data: {
            role: 'ORGANISME',
            domaines: ['VIN'],
            menu: { icon: 'file-export', libelle: 'menu.export' }
        },
        children: [
            {
                path: '',
                redirectTo: 'generation-documents',
                pathMatch: 'full'
            },
            {
                path: 'generation-habilitations',
                component: GenerationHabilitationsComponent,
                data: {
                    menu: { libelle: 'Habilitations' },
                    title: 'Export des habilitations'
                }
            },
            {
                path: 'generation-parcellaires',
                component: SuiviParcellairesViticolesComponent,
                data: {
                    menu: { libelle: 'Parcellaires' },
                    title: 'Export des parcellaires'
                }
            },
            {
                path: 'generation-declarations',
                component: GenerationDeclarationsComponent,
                data: {
                    menu: { libelle: 'Déclarations' },
                    title: 'Export des déclarations'
                }
            },
            {
                path: 'generation-jure',
                component: GenerationJuresComponent,
                data: {
                    menu: { libelle: 'Jurés' },
                    title: 'Export des jurés'
                }
            },
            {
                path: 'generation-echantillon',
                component: GenerationEchantillonsComponent,
                data: {
                    menu: { libelle: 'Échantillons' },
                    title: 'Export des échantillons'
                }
            },
            {
                path: 'generation-operateur',
                component: GenerationOperateursComponent,
                data: {
                    menu: { libelle: 'Opérateurs' },
                    title: 'Export des opérateurs'
                }
            }
        ]
    }
];
